import * as Yup from "yup";

import { Modal } from "components";
import toast from "react-hot-toast";
import { useFormik } from "formik";
import { useMutation } from "@apollo/client";
import { wrapClick } from "utils";
import CreateLimitForm from "components/forms/create-limit-form";
import {
  AddKavaPremiumMemberLimit,
  AddKavaPremiumMemberLimitVariables,
} from "_graphql/visal/mutations/__generated__/AddKavaPremiumMemberLimit";
import { ADD_KAVA_PREMIUM_MEMBER_LIMIT } from "_graphql/visal/mutations/premium-limit";

export const insurerRepValidationSchema = Yup.object().shape({
  participationLowerLimit: Yup.number()
    .min(0, "Participation Lower Limit must be at least 0")
    .required("Participation Lower Limit is required"),
});

export default function CreateLimitContainer({
  open,
  setOpen,
  premiumMemberId,
  refetch,
}: {
  open: boolean;
  premiumMemberId?: string;
  setOpen: (val: boolean) => void;
  refetch?: () => void;
}) {
  const [create, { loading }] = useMutation<
    AddKavaPremiumMemberLimit,
    AddKavaPremiumMemberLimitVariables
  >(ADD_KAVA_PREMIUM_MEMBER_LIMIT);

  const form = useFormik<any>({
    initialValues: {
      participationLowerLimit: 0,
    },
    validationSchema: insurerRepValidationSchema,
    onSubmit: async (variables) => {
      await create({
        variables: {
          premiumMemberId: premiumMemberId || "",
          participationLowerLimit: variables?.participationLowerLimit,
        },
      }).then(({ data }) => {
        if (data?.addKavaPremiumMemberLimit) {
          toast.success("Kava Premium Member Limit added successfully");
          refetch?.();
          form.resetForm();
        } else {
          toast.error("Failed to add Kava Premium Member Limit");
        }
      });
    },
    onReset: () => {
      setOpen(false);
    },
  });

  return (
    <Modal
      open={open}
      setOpen={setOpen}
      title="Add Kava Premium Limit"
      description="Fill in the details below to add new Kava Premium Limit"
      renderActions={() => (
        <>
          <button
            type="button"
            disabled={loading}
            className="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-primary-600 text-base font-medium text-white hover:bg-primary-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500 sm:ml-3 sm:w-auto sm:text-sm"
            onClick={wrapClick(form.handleSubmit)}
          >
            {loading ? "Adding Limit ...." : "Add Limit"}
          </button>
        </>
      )}
    >
      <CreateLimitForm form={form} />
    </Modal>
  );
}
